import { useVirtualizer } from "@tanstack/react-virtual"
import { useRef, useMemo, useCallback } from "react"

export function useVirtualizedList<T extends { id: string }>(data: T[]) {
    const parentRef = useRef<HTMLDivElement>(null)
    const dataRef = useRef(data)
    dataRef.current = data
    const flattenedLayersKey = useMemo(() => data.map((layer) => layer.id).join(","), [data])
    const getItemKey = useCallback(
        (i: number) => dataRef.current[i].id,
        // We need tanstack to recalculate heights when the order of ids change.
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [flattenedLayersKey]
    )
    const virtualizer = useVirtualizer({
        count: data.length,
        getScrollElement: () => parentRef.current,
        estimateSize: () => 62,
        overscan: 5,
        getItemKey,
    })
    return {
        parentRef,
        virtualizer,
    }
}
